/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="83.7" height="72" viewBox="0 0 83.7 72" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path fill="none" stroke="#4a4a4a" d="M17.5 25.2H4.8a3.33 3.33 0 0 0-3.3 3.3v38.7a3.33 3.33 0 0 0 3.3 3.3h74.1a3.33 3.33 0 0 0 3.3-3.3V28.5a3.33 3.33 0 0 0-3.3-3.3H67.3" className="icon-stroke" strokeWidth="3" strokeMiterlimit="10"/>
        <path fill="#4a4a4a" d="M63.2 3A2.8 2.8 0 0 1 66 5.8v37.7H17.9V5.8A2.8 2.8 0 0 1 20.7 3h42.5m0-3H20.6a5.8 5.8 0 0 0-5.8 5.8v40.7h53.6a.54.54 0 0 0 .5-.5V5.8A5.72 5.72 0 0 0 63.2 0Z" className="icon-fill"/>
        <g fill="none" stroke="#4a4a4a" className="icon-stroke" strokeWidth="3" strokeMiterlimit="10">
          <path d="M24.3 13h35.2M24.3 23.2h35.2M24.3 33.4h35.2"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'FaxIcon';

export default Icon;
